module.exports = __webpack_public_path__ + "img/meatsSmall.51de6529.jpg";